import {getStyle} from "@/assets/plugins/mps-common/style/style";

export default {
    install(Vue, options) {
        Vue.prototype.$getStyle = getStyle // parameters are (el, styleName)
    }
}